import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  SelectionState,
  ContentState,
  convertFromHTML,
  EditorState,
  Modifier,
  RichUtils,
  CompositeDecorator
} from "draft-js";
import { useHistory } from "react-router-dom";
import { Editor } from "react-draft-wysiwyg";
import htmlToDraft from "html-to-draftjs";
import {stateToHTML} from 'draft-js-export-html';
import { useCookies } from "react-cookie";
import { getSelectedBlock } from "draftjs-utils";
import {stateFromHTML} from 'draft-js-import-html';
import {
  ArrowRightOutlined,
  CopyFilled,
} from "@ant-design/icons";

import {
  CardHeader,
  CopyIconStyles,
  Quote,
  ResultWrapper,
  SuggestionWrapper,
  TranscriptionWrapper,
} from "./styles";
import { Container, Label } from "../../styles";
import { OrderedSet } from 'immutable'
import { Button as AntButton, Col, List, message, Row, Skeleton, Modal, Tag } from "antd";
import Dashboard from "../../assets/dashbord_icon.svg";
import Button from "./../../components/Shared/Button";
import ArrowRight from "../../assets/arrow-right.svg";
import ArrowLeft from "../../assets/arrow-left.svg";
import CopyIcon from "../../assets/copy_icon.svg";

import Bold from "../../assets/bold.svg";
import Italic from "../../assets/italic.svg";
import Underline from "../../assets/underline.svg";
import Undo from "../../assets/undo.svg";
import StrikeThrough from "../../assets/strikethrough.svg";
import FontSize from "../../assets/fontsize.svg";
import Redo from "../../assets/redo.svg";
import UnorderedList from "../../assets/unorderlist.svg";
import OrdersList from "../../assets/orderlist.svg";
import IndentList from "../../assets/indent.svg";
import OutdentList from "../../assets/outdent.svg";
import LeftAlign from "../../assets/leftalign.svg";
import RightAlign from "../../assets/rightalign.svg";
import CenterAlign from "../../assets/centeralign.svg";
import Justify from "../../assets/justify.svg";
import LinkIcon from "../../assets/link.svg";

import getFragmentFromSelection from "draft-js/lib/getFragmentFromSelection";
import appActions from "../../modules/app/appActions";
import { Card } from "react-bootstrap";
import appSelectors from "../../modules/app/appSelectors";
import { dummyquotes } from "./dummydata";
import EditBlog from "../EditBlog/EditBlog";
import PaywallPopup from "../../components/Paywall Popup/PaywallPopup";
import { collection, getDocs } from "@firebase/firestore";
import { db } from "../../firebase";
import { getAuth } from "firebase/auth";
import { randomIntFromInterval, sleep } from "../../Utils";
import axios from "axios";


const Link = ({ entityKey, contentState, children }) => {
  let { url } = contentState.getEntity(entityKey).getData();
  return (
    <a
      style={{ color: "red", fontStyle: "italic" }}
      href={url}
      target="_blank"
    >
      {children}
    </a>
  );
};

const findLinkEntities = (contentBlock, callback, contentState) => {
  contentBlock.findEntityRanges((character) => {
    const entityKey = character.getEntity();
    return (
      entityKey !== null &&
      contentState.getEntity(entityKey).getType() === "LINK"
    );
  }, callback);
};
const createLinkDecorator = () =>
  new
  CompositeDecorator
  ([
    {
      strategy: findLinkEntities,
      component: Link,
    },
  ]);


const injectStyle = (style) => {
  const styleElement = document.createElement('style');
  let styleSheet = null;
  
  document.head.appendChild(styleElement);
  
  styleSheet = styleElement.sheet;
  
  styleSheet.insertRule(style, styleSheet.cssRules.length);
};

const keyframesStyle = `@-webkit-keyframes dots {
        0%, 20% {
            color: rgba(0,0,0,0);
            text-shadow: .25em 0 0 rgba(0,0,0,0), .5em 0 0 rgba(0,0,0,0)
          }
        40% {
            color: white;
            text-shadow: .25em 0 0 rgba(0,0,0,0), .5em 0 0 rgba(0,0,0,0)
          }
        60% {
           
            text-shadow: .25em 0 0 white, .5em 0 0 rgba(0,0,0,0)
          }
        80%, 100% {
            
            text-shadow: .25em 0 0 white, .5em 0 0 white
          }
      }`;


const Index = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [resultText, setResultText] = useState("");
  const [selectedSelection, setSelectedSelection] = useState();
  const [leftActionText, setLeftActionText] = useState("");
  const [selectedWordsCount, setSelectedWordsCount] = useState(0);
  const [totalWordsCount, setTotalWordsCount] = useState(0);
  const [pageLoading, setPageLoading] = useState(false);
  const [quotesLoading, setQuotesLoading] = useState(false);
  const [resultLoading, setResultLoading] = useState(false);
  const [guid, setGuid] = useState("");
  const [useText, setUseText] = useState({});
  const [cookies, setCookie] = useCookies(["ytb-id"]);
  const [popup, setpopup] = useState(false);
  const [quotes, setQuotes] = useState([])
  const [loaderVisible, _setLoaderVisible] = useState(false);
  
  const [editorState, _setEditorState] = useState(EditorState.createEmpty());
  const [mode, setMode] = useState("edit");
  const [updateState, setStateUpdated] = useState(false)
  const [placeHolderVisible, _setPlaceholderVisible] = useState(false)
  const [placeholderContent, _setPlaceholderContent] = useState('')
  const [autoCompleteId, _setAutocompleteId] = useState(-1)
  
  const editorRef = useRef(editorState);
  const placeHolderRef = useRef(placeHolderVisible)
  const placeholderContentRef = useRef(placeholderContent)
  const autoIdRef = useRef(autoCompleteId);
  const [showToolTip, _setShowTooltip] = useState(false);
  const tooltipRef = useRef(showToolTip);
  const editorInsRef = useRef();
  const loaderRef = useRef();
  let timer = null
  
  const userBlogs = useSelector(appSelectors.selectUserBlogs);
  
  const setAutocompleteId = (id) => {
    _setAutocompleteId(id)
    autoIdRef.current = id
  }
  
  const setShowTooltip = (show) => {
    _setShowTooltip(show)
    tooltipRef.current = show
  }
  const setLoaderVisible = (show) => {
    _setLoaderVisible(show)
    loaderRef.current = show
  }
  
  const setPlaceholderContent = (content) => {
    _setPlaceholderContent(content)
    placeholderContentRef.current = content
  }
  
  const setPlaceholderVisible = (visible) => {
    _setPlaceholderVisible(visible)
    placeHolderRef.current = visible
  }
  
  const setEditorState = (state) => {
    _setEditorState(state)
    editorRef.current = state
  }
  
  function handleResize(e) {
    setWindowWidth(window.innerWidth);
  }
  
  const handleKeyup = (e) => {
    
    console.log('e.keyCode', e.keyCode)
    if ((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 65 && e.keyCode <= 90)) {
      if (placeHolderRef.current) {
        removePlaceHolder(editorRef.current)
      }
    }
  }
  
  
  useEffect(() => {
    injectStyle(keyframesStyle);
  }, [])
  
  const styleMap = {
    HIGHLIGHT: {
      fontSize: 30,
      lineHeight: '0.1em',
      WebkitAnimation: 'dots 1s linear infinite alternate',
    },
    PLACEHOLDER: {
      color: 'lightGrey'
    },
    TEXT: {
      color: '#7c82a7'
    }
  };
  
  useEffect(() => {
    if (userBlogs) {
      loadBlogData()
    }
    
  }, [userBlogs]);
  
  const currentuser = getAuth().currentUser;
  
  useEffect(async () => {
    const docRef = collection(db, "FreeTrialUsers");
    const snapShot = await getDocs(docRef);
    
    snapShot.docs.forEach((doc) => {
        if (doc.id === currentuser.uid) {
          if (doc._document.data.value.mapValue.fields.freetrial.booleanValue) {
            setpopup(false)
          } else {
            setpopup(true)
          }
        }
      }
    );
    
  }, []);
  
  const loadBlogData = async ()=>{
    try {
      setPageLoading(true)
      const response = await axios.get(`https://api.tube2blog.com:5000/job/${props.match.params.id}`)
      if(response.status === 200){
        loadNewBlog(userBlogs[props.match.params.id], response.data.chapters);
      }
    }catch (e) {
      setPageLoading(false)
      console.log(e)
    }
  }
  
  const getQuotes = (blog) => {
    //setQuotesLoading(true)
    setQuotes(blog)
  };
  
  const loadNewBlog = (blog, chapters) => {
    console.log('loadNewBlog', blog)
    if (!blog) return;
    const paragraphs = blog.blog;
    getQuotes(paragraphs);
    let html = ``;
    chapters.forEach((chapter) => {
      html += `<h2>${chapter.title}</h2>`;
      if(chapter.thumbnail){
        html += `<img style="width: 650px;" src="${chapter.thumbnail}"/>`;
      }
      html += `<p>${chapter.text.trim()}</p><br/><br/>`;
    });
    const contentBlock = htmlToDraft(html);
    const contentState = ContentState.createFromBlockArray(
      contentBlock.contentBlocks
    );
    const decorator = createLinkDecorator();
    const _editorState = EditorState.createWithContent(contentState, decorator);
    setEditorState(_editorState);
    setPageLoading(false);
  };
  
  useEffect(() => {
    window.addEventListener("resize", handleResize);
    //window.addEventListener("keyup", handleKeyup);
    return () => {
      window.removeEventListener("resize", handleResize)
      //window.removeEventListener("keyup", handleKeyup)
    };
  }, []);
  
  const toggleInlineStyle = async (inlineStyle, selection, editorState) => {
    try {
      const editorStateWithAllSelection = EditorState.acceptSelection(
        editorState,
        selection
      );
      
      const newState = RichUtils.toggleInlineStyle(
        editorStateWithAllSelection,
        inlineStyle
      );
      if (selectedSelection) {
        const editorStateWithSelectionOld = EditorState.acceptSelection(
          newState,
          selectedSelection
        );
        try {
          const finalState = RichUtils.toggleInlineStyle(
            editorStateWithSelectionOld,
            inlineStyle
          );
          await setEditorState(finalState);
        } catch (e) {
          await setEditorState(newState);
        }
      } else {
        const editorStateWithSelectionBefore = EditorState.acceptSelection(
          newState,
          selection
        );
        await setEditorState(editorStateWithSelectionBefore);
      }
    } catch (e) {
      await setEditorState(editorState);
    }
  };
  
  const replaceText = async (text) => {
    try {
      const contentState = Modifier.replaceText(
        editorState.getCurrentContent(),
        selectedSelection,
        text
      );
      const newState = EditorState.push(
        editorState,
        contentState,
        "insert-characters"
      );
      
      const selected = getFragmentFromSelection(newState);
      if (selected) {
        const selection = newState.getSelection();
        await toggleInlineStyle("HIGHLIGHT", selection, editorState);
      }
      
      setEditorState(newState);
    } catch (e) {
      console.log(e);
    }
    resetEditMode();
  };
  
  const downloadFile = () => {
    let html = stateToHTML(editorState.getCurrentContent());
    const element = document.createElement("a");
    element.setAttribute(
      "href",
      "data:text/plain;charset=utf-8," + encodeURIComponent(html)
    );
    element.setAttribute("download", "transcript.html");
    
    element.style.display = "none";
    document.body.appendChild(element);
    
    element.click();
    
    document.body.removeChild(element);
  };
  
  const handlePastedText = (text, html, editorState, onChange) => {
    console.log('text', text, html)
    placeHolderRef.current = true
    const selectedBlock = getSelectedBlock(editorState);
    if (selectedBlock && selectedBlock.type === 'code') {
      const contentState = Modifier.replaceText(
        editorState.getCurrentContent(),
        editorState.getSelection(),
        text,
        editorState.getCurrentInlineStyle(),
      );
      onChange(EditorState.push(editorState, contentState, 'insert-characters'));
      placeHolderRef.current = false
      return true;
    } else if (html) {
      const blockMap = stateFromHTML(html).blockMap;
      const newState = Modifier.replaceWithFragment(
        editorState.getCurrentContent(),
        editorState.getSelection(),
        blockMap,
      );
      onChange(EditorState.push(editorState, newState, 'insert-fragment'));
      placeHolderRef.current = false
      return true;
    }
    placeHolderRef.current = false
    return false;
  };
  
  function copyToClipboard(quote) {
    const source  = `${quote.paragraph}`
    const input = document.createElement('input');
    input.setAttribute('value', source);
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    document.body.removeChild(input);
    message.success("Copied to clipboard");
  }
  
  const resetEditMode = async () => {
    setMode("edit");
    setSelectedSelection(null);
    //setSelectedText('')
    //toggleLayerProps.close()
    setUseText({});
    setResultText(null);
  };
  const transformText = async () => {
    setResultLoading(true);
    const selected = getFragmentFromSelection(editorState);
    if (selected) {
      const selection = editorState.getSelection();
      await toggleInlineStyle("HIGHLIGHT", selection, editorState);
      setSelectedSelection(selection);
    }
    const selectedText = selected
      ? selected.map((x) => x.getText()).join("\n")
      : "";
    //setSelectedText(selectedText)
    let text = editorState.getCurrentContent().getPlainText("\u0001");
    setTotalWordsCount(text.length);
    // toggleLayerProps.close()
    const content = selected ? selectedText : text;
    let type = mode === "blog-ify" ? "rephrase" : mode;
    if (mode === "summary") {
      type = "expander";
    }
    dispatch(appActions.transform(guid, type, content)).then(
      (data) => {
        setResultLoading(false);
        setResultText(data);
      },
      (error) => {
        setResultLoading(false);
        console.log(error);
      }
    );
  };
  
  if (pageLoading) {
    return (
      <TranscriptionWrapper toolbarWidth={windowWidth}>
        <Container>
          <Skeleton active/>
          <Skeleton active/>
          <Skeleton active/>
          <Skeleton active/>
        </Container>
      </TranscriptionWrapper>
    );
  }
  
  function getBlockStyle(block) {
    return "blockStyle";
  }
  
  const Suggestion = ({ quote }) => {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        borderBottom: '1px solid #D3D6EB',
        paddingTop: 10,
        paddingBottom: 25,
        marginRight: 20
      }}>
        <img
          src={CopyIcon}
          style={{ alignSelf: 'flex-end', width: 20, marginBottom: 5, cursor: 'pointer' }}
          alt={'Copy'}
          onMouseEnter={() =>  copyToClipboard(quote)}
        />
        <h2>{quote.heading}</h2>
        <span
          style={{ color: '#7C82A7', fontSize: 14, fontFamily: 'Roboto' }}
        >
          {quote.paragraph}
        </span>
      </div>
    )
  }
  
  const PAGE = ({ title, suggestions, onSelect }) => {
    return (
      <>
        <Card.Title>{title}</Card.Title>
        <List
          style={{ height: 450, overflowY: "scroll", padding: 5 }}
          dataSource={suggestions}
          renderItem={(item) => (
            <Card style={{ width: "100%", minHeight: 60, marginBottom: 20 }}>
              <Card.Body
                style={{
                  padding: 0,
                  paddingLeft: 20,
                  paddingTop: 10,
                  paddingRight: 20,
                }}
              >
                <Label>
                  {item.text.split("\n").map((str) => (
                    <p style={{ marginBottom: 0 }}>{str}</p>
                  ))}
                </Label>
                <div
                  style={{
                    width: "100%",
                    justifyContent: "flex-start",
                    alignItems: "center",
                  }}
                >
                  <AntButton
                    onClick={() => {
                      const _useText = { ...useText };
                      if (useText && useText[item.id]) delete _useText[item.id];
                      else _useText[item.id] = item;
                      setUseText(_useText);
                    }}
                    style={{
                      color: "#4A60F4",
                      marginRight: 10,
                      display: "flex",
                      alignItems: "center",
                      padding: 0,
                    }}
                    type={"link"}
                  >
                    {useText[item.id] ? "Remove" : "use this"}
                    <ArrowRightOutlined/>
                  </AntButton>
                </div>
              </Card.Body>
            </Card>
          )}
        />
      </>
    );
  };
  
  const HandleCopyQuote = (e) => {
    const copytext = e.currentTarget.parentElement.childNodes[0].innerText;
    const textarea = document.createElement("textarea");
    textarea.value = copytext;
    document.body.append(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
  };
  
  const getCurrentBlock = (editorState) => {
    const currentSelection = editorState.getSelection();
    const blockKey = currentSelection.getStartKey();
    return (editorState.getCurrentContent().getBlockForKey(blockKey));
  }
  
  const getCurrentText = (editorState) => {
    const currentBlock = getCurrentBlock(editorState);
    const blockText = currentBlock.getText();
    var selectionState = editorState.getSelection();
    var end = selectionState.getEndOffset();
    const nextText = blockText.slice(end, end + 5)
    const match = /\r|\n/.exec(nextText);
    if (match || nextText.trim() === '') {
      return blockText.slice(0, end);
    } else return ''
  }
  
  const addspace = async (editorState, id) => {
    if (id === autoIdRef.current) {
      const text = ' '
      const currentContent = editorState.getCurrentContent();
      const currentSelection = editorState.getSelection();
      const newContent = Modifier.replaceText(
        currentContent,
        currentSelection,
        text
      );
      const anchorOffset = currentSelection.getAnchorOffset();
      const newSelection = new SelectionState({
        anchorKey: currentSelection.getAnchorKey(),
        anchorOffset,
        focusKey: currentSelection.getAnchorKey(),
        focusOffset: anchorOffset,
      });
      const newEditorState = EditorState.push(editorState, newContent, 'insert-characters');
      const newSate = EditorState.forceSelection(newEditorState, newSelection);
      setEditorState(newSate)
    }
  }
  
  const showLoader = (editorState, id) => {
    if (!loaderRef.current && id === autoIdRef.current) {
      setLoaderVisible(true)
      const text = '•••'
      const currentContent = editorState.getCurrentContent();
      const currentSelection = editorState.getSelection();
      const newContent = Modifier.replaceText(
        currentContent,
        currentSelection,
        text,
        OrderedSet.of('HIGHLIGHT')
      );
      const anchorOffset = currentSelection.getAnchorOffset();
      const newSelection = new SelectionState({
        anchorKey: currentSelection.getAnchorKey(),
        anchorOffset,
        focusKey: currentSelection.getAnchorKey(),
        focusOffset: anchorOffset,
      });
      const newEditorState = EditorState.push(editorState, newContent, 'insert-characters');
      const newSate = EditorState.forceSelection(newEditorState, newSelection);
      setEditorState(newSate)
    }
  }
  
  const hideLoader = (editorState) => {
    if (loaderRef.current) {
      const state = EditorState.undo(editorState)
      setEditorState(EditorState.undo(state))
      setLoaderVisible(false)
    }
  }
  
  const insertPlaceHolder = async (content, editorState, id) => {
    if (id === autoIdRef.current && !placeHolderRef.current) {
      const _state = EditorState.undo(editorState)
      setShowTooltip(true)
      const text = await appActions.getAutoComplete(content)
      console.log('text', text)
      const currentContent = _state.getCurrentContent();
      const currentSelection = _state.getSelection();
      const newContent = Modifier.replaceText(
        currentContent,
        currentSelection,
        text,
        OrderedSet.of('PLACEHOLDER')
      );
      const anchorOffset = currentSelection.getAnchorOffset();
      const newSelection = new SelectionState({
        anchorKey: currentSelection.getAnchorKey(),
        anchorOffset,
        focusKey: currentSelection.getAnchorKey(),
        focusOffset: anchorOffset,
      });
      const newEditorState = EditorState.push(_state, newContent, 'insert-characters');
      const newSate = EditorState.forceSelection(newEditorState, newSelection);
      const _content = getCurrentText(_state)
      console.log('c1',content)
      console.log('c2',_content)
      if(content === _content) {
        setEditorState(newSate)
        setPlaceholderContent(text)
        setPlaceholderVisible(true)
      }
    }
  }
  
  const removePlaceHolder = async (editorState) => {
    console.log('removePlaceHolder', placeHolderRef.current)
    /*const currentContent = editorState.getCurrentContent();
    const currentSelection = editorState.getSelection();
    const newContent = Modifier.replaceText(
      currentContent,
      currentSelection,
      placeholderContent,
      OrderedSet.of('TEXT')
    );
    const newEditorState = EditorState.push(editorState, newContent, 'delete-character');
    const newSate = EditorState.forceSelection(newEditorState, currentSelection);*/
    if (placeHolderRef.current) {
      const state = EditorState.undo(editorState)
      setEditorState(EditorState.undo(state))
      setShowTooltip(false)
      setLoaderVisible(false)
      setTimeout(() => {
        setPlaceholderVisible(false)
      }, 200)
    }
  }
  
  const insertText = async (editorState, id) => {
    // const _state = EditorState.undo(editorState)
    if (id === autoIdRef.current && placeHolderRef.current) {
      const _state = EditorState.undo(editorState)
      const currentContent = _state.getCurrentContent();
      const currentSelection = _state.getSelection();
      const newContent = Modifier.replaceText(
        currentContent,
        currentSelection,
        placeholderContentRef.current,
        OrderedSet.of('TEXT')
      );
      const anchorOffset = currentSelection.getAnchorOffset();
      const newSelection = new SelectionState({
        anchorKey: currentSelection.getAnchorKey(),
        anchorOffset: anchorOffset + placeholderContentRef.current.length,
        focusKey: currentSelection.getAnchorKey(),
        focusOffset: anchorOffset + placeholderContentRef.current.length,
      });
      const newEditorState = EditorState.push(_state, newContent, 'insert-characters');
      const newSate = EditorState.forceSelection(newEditorState, newSelection);
      setEditorState(newSate)
      setPlaceholderContent('')
      setPlaceholderVisible(false)
      setAutocompleteId(-1)
      setShowTooltip(false)
      setLoaderVisible(false)
    }
  }
  const replaceSuggestions = async () => {
    
    const id = randomIntFromInterval(10000, 99999)
    setAutocompleteId(id)
    timer = setTimeout(async () => {
      if (id === autoIdRef.current) {
        await removePlaceHolder(editorRef.current)
        const content = getCurrentText(editorRef.current)
        await addspace(editorRef.current, id)
        await showLoader(editorRef.current, id)
        // await sleep(2*1000);
        //insertLink('LINK',{},'tt')
        const _state = EditorState.undo(editorRef.current)
        setShowTooltip(true)
        const text = await appActions.getAutoComplete(content)
        console.log('text', text)
        const currentContent = _state.getCurrentContent();
        const currentSelection = _state.getSelection();
        const newContent = Modifier.replaceText(
          currentContent,
          currentSelection,
          text,
          OrderedSet.of('PLACEHOLDER')
        );
        const anchorOffset = currentSelection.getAnchorOffset();
        const newSelection = new SelectionState({
          anchorKey: currentSelection.getAnchorKey(),
          anchorOffset,
          focusKey: currentSelection.getAnchorKey(),
          focusOffset: anchorOffset,
        });
        const newEditorState = EditorState.push(_state, newContent, 'insert-characters');
        const newSate = EditorState.forceSelection(newEditorState, newSelection);
        setEditorState(newSate)
        setPlaceholderContent(text)
        setPlaceholderVisible(true)
      }
      clearTimeout(timer)
      timer = null
    }, 1000)
  }
  
  
  const getAutComplete = async (force) => {
    if (!timer) {
      clearTimeout(timer)
      timer = null
    }
    if (force) {
      hideLoader(editorRef.current)
    }
    if (!placeHolderRef.current) {
      const id = randomIntFromInterval(10000, 99999)
      setAutocompleteId(id)
      timer = setTimeout(async () => {
        const content = getCurrentText(editorRef.current)
        if (id === autoIdRef.current && content.length>0) {
          await addspace(editorRef.current, id)
          await showLoader(editorRef.current, id)
          // await sleep(2*1000);
          //insertLink('LINK',{},'tt')
          await insertPlaceHolder(content, editorRef.current, id)
        }
        clearTimeout(timer)
        timer = null
      }, 1000)
    }
  }
  
  const insertLink = (type, data, text) => {
    const editorState = editorRef.current;
    const contentState = editorState.getCurrentContent();
    const selection = editorState.getSelection();
    const textWithSpace = text.concat(' ');
    // create new content with text
    const newContent = Modifier.insertText(
      contentState,
      selection,
      textWithSpace
    );
    // create new link entity
    const newContentWithEntity = newContent.createEntity(
      type,
      'MUTABLE',
      data,
      false,
    );
    const entityKey = newContentWithEntity.getLastCreatedEntityKey();
    // create new selection with the inserted text
    const anchorOffset = selection.getAnchorOffset();
    const newSelection = new SelectionState({
      anchorKey: selection.getAnchorKey(),
      anchorOffset,
      focusKey: selection.getAnchorKey(),
      focusOffset: anchorOffset + text.length,
    });
    // and aply link entity to the inserted text
    const newContentWithLink = Modifier.applyEntity(
      newContentWithEntity,
      newSelection,
      entityKey,
    );
    // create new state with link text
    const withLinkText = EditorState.push(
      editorState,
      newContentWithLink,
      'insert-characters',
    );
    // now lets add cursor right after the inserted link
    const withProperCursor = EditorState.forceSelection(
      withLinkText,
      newContent.getSelectionAfter(),
    );
    // update the editor with all changes
    setEditorState(withProperCursor)
  };
  
  return (
    <TranscriptionWrapper toolbarWidth={windowWidth}>
      {popup ? (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            zIndex: 9999,
          }}
        >
          <PaywallPopup id={props.match.params.id}/>
        </div>
      ) : null}
      <Container className={"blog-container"}>
        <Row justify="space-between" gutter={[0, 6]} className="steps-content2">
          <CardHeader>
            <Col xs={24}>
              <div className="right-wrapper">
                <div className="arrows-wrapper">
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Button
                      veriant="primary"
                      handleClick={() => history.push("/upload1")}
                      size="small-medium"
                      type="submit"
                    >
                      <img
                        alt={"Dashboard"}
                        width={15}
                        height={15}
                        style={{ marginRight: 5 }}
                        src={Dashboard}
                      />
                      Start again
                    </Button>
                  </div>
                  <AntButton
                    onClick={downloadFile}
                    className="export-btn"
                    size="medium"
                  >
                    Export
                    {/*<img src={Download} style={{marginLeft: 5}} alt={'Export file'}/>*/}
                  </AntButton>
                
                </div>
              </div>
            </Col>
          </CardHeader>
          <Row className={"contentWrapper"}>
            <Col xs={10}>
              <SuggestionWrapper>
                {quotesLoading &&
                <>
                  <Skeleton active/>
                  <Skeleton active/>
                  <Skeleton active/>
                  <Skeleton active/>
                </>
                }
                {!quotesLoading && quotes.map((quote) => <Suggestion quote={quote}/>)}
              </SuggestionWrapper>
            </Col>
            <Col xs={mode === 'edit' ? 14 : 12}>
              <Editor
                ref={editorInsRef}
                blockStyleFn={getBlockStyle}
                customStyleMap={styleMap}
                editorState={editorState}
                toolbarClassName="editorToolbar"
                wrapperClassName="editorWrapper"
                editorClassName="editorContent"
                editorStyle={{
                  boxShadow:
                    mode !== "edit"
                      ? "0px 1px 1px 1px rgba(0,0,0,0.1)"
                      : "none",
                  paddingLeft: mode === "edit" ? 10 : 20,
                  paddingRight: mode === "edit" ? 25 : 20,
                  
                }}
                onEditorStateChange={(editorState) => {
                  setEditorState(editorState);
                  //getAutComplete()
                  //editorRef.current = editorState;
                  /*const selected = getFragmentFromSelection(editorState);
                  const selectedWords = selected
                    ? selected.map((x) => x.getText()).join("\n")
                    : "";
                  let text = editorState
                    .getCurrentContent()
                    .getPlainText("\u0001");
                  setSelectedWordsCount(selectedWords.length);
                  setTotalWordsCount(text.length);*/
                  //getAutComplete();
                  // toggleInlineStyle("HIGHLIGHT", editorState.getSelection(), editorState);
                }}
                toolbar={{
                  options: [
                    "history",
                    "inline",
                    "blockType",
                    "fontSize",
                    "colorPicker",
                    "list",
                    "textAlign",
                    "link",
                    "embedded",
                    "emoji",
                    "image",
                    "remove",
                  ],
                  inline: {
                    options: ["bold", "italic", "underline", "strikethrough"],
                    bold: { icon: Bold },
                    italic: { icon: Italic },
                    underline: { icon: Underline },
                    strikethrough: { icon: StrikeThrough },
                  },
                  blockType: {
                    inDropdown: false,
                    options: ["Normal", "H1", "H2"],
                  },
                  history: {
                    options: ["undo", "redo"],
                    undo: { icon: Undo },
                    redo: { icon: Redo },
                  },
                  fontSize: {
                    icon: FontSize,
                  },
                  list: {
                    inDropdown: false,
                    options: ["unordered", "ordered", "indent", "outdent"],
                    unordered: { icon: UnorderedList },
                    ordered: { icon: OrdersList },
                    indent: { icon: IndentList },
                    outdent: { icon: OutdentList },
                  },
                  textAlign: {
                    options: ["left", "center", "right", "justify"],
                    left: { icon: LeftAlign },
                    center: { icon: CenterAlign },
                    right: { icon: RightAlign },
                    justify: { icon: Justify },
                  },
                  link: {
                    options: ["link"],
                    link: { icon: LinkIcon },
                  },
                }}
              />
            </Col>
            {/*{mode !== 'edit' &&
              <Col xs={12} style={{ padding: `0 20px 20px 20px`, marginTop: 40 }}>
                <ResultWrapper>
                  {resultLoading &&
                  <>
                    <Skeleton active/>
                    <Skeleton active/>
                    <Skeleton active/>
                  </>
                  }
                  {!resultLoading && resultText && <PAGE suggestions={resultText}/>}
                </ResultWrapper>
              </Col>
            }*/}
          </Row>
          {mode !== 'edit' && <Row className={"actionWrapper"}>
            <Col
              xs={12}
              className={"action"}
              style={{ display: 'flex', justifyContent: 'space-between' }}>
              <span className={'wordsSelection'}>{`${selectedWordsCount}/${totalWordsCount} words selected`}</span>
              <Button
                veriant="primary"
                handleClick={() => {
                  transformText()
                }}
                size="small"
                type="submit"
              >
                {leftActionText}
                <img
                  alt={'Dashboard'}
                  width={15}
                  height={15}
                  style={{ marginLeft: 10 }}
                  src={ArrowRight}
                />
              </Button>
            </Col>
            <Col xs={12} className={"action"}>
              <Button
                veriant="primary"
                handleClick={() => {
                  if (resultText && resultText.length > 0) {
                    let _content = ''
                    resultText.forEach((rsText) => {
                      if (useText[rsText.id]) {
                        _content += ` ${rsText.text}`
                      }
                    })
                    if (_content && _content.length > 0)
                      replaceText(_content)
                    else {
                      resetEditMode()
                    }
                  }
                }}
                size="small"
                type="submit"
              >
                <img
                  alt={'Dashboard'}
                  width={15}
                  height={15}
                  style={{ marginRight: 10 }}
                  src={ArrowLeft}
                />
                Replace text
              </Button>
            </Col>
          </Row>}
        </Row>
      </Container>
      {showToolTip && <div style={{position: 'fixed', left: '10%', right: '10%', bottom:'3%', backgroundColor:'white'}}>
        Press <Tag color="green">Tab ↹</Tag>on your keyboard to accept the suggestion. Press <Tag
        color="red">shift</Tag>+ <Tag color="red">Tab ↹ </Tag> to see a different suggestion.
      </div>}
    </TranscriptionWrapper>
  );
};

export default Index;
